import CryptoJS from "crypto-js";

// Decode String from Base64 Enconding
export function decodeBase64(encodedValue: string) {
  const words = CryptoJS.enc.Base64.parse(encodedValue);
  const textString = CryptoJS.enc.Utf8.stringify(words);
  return textString;
}